import styled from "styled-components/macro";
import { DefaultFont } from "../../../../styles/fonts";

export const PostTitle = styled.h1`
  font-weight: 600;
  font-size: 40px;
  line-height: 0.5em;
  color: #032565;
  text-align: left;
  margin-top: 0.5em;
  margin-bottom: 0 !important;
`;

export const TitleH2Other = styled.h2<{ m?: string }>`
  color: ${(props) => props.theme.colors.text};
  font-size: ${(props) => props.theme.font.sizeSubTitle};
  font-weight: ${(props) => props.theme.font.weightMedium};
  margin: ${(props) => props.m || "0"};
  align-self: flex-start;
`;

export const TitleH3Other = styled.h3`
  color: ${(props) => props.theme.colors.text};
  font-size: ${(props) => props.theme.font.size};
  font-weight: ${(props) => props.theme.font.weightMedium};
  margin-bottom: 4px;
  align-self: flex-start;
`;

export const BlogBackDiv = styled.div`
  display: flex;
  justify-items: flex-start;
  width: 100%;
  & > a {
    color: ${(props) => props.theme.colors.primary};
    font-size: 16px;
    line-height: 3px;
    &:hover {
      color: ${(props) => props.theme.colors.fourtly};
      & > svg path {
        stroke: ${(props) => props.theme.colors.fourtly};
        transition: 0.3s all ease;
      }
    }
    & > svg {
      transition: 0.3s all ease;
      margin-right: 8px;
      vertical-align: text-bottom;
      position: relative;
      top: 0.05em;
    }
  }
`;

export const CardBlogDiv = styled.div`
  transition: 0.3s background-color;
  cursor: pointer;
  flex: 1 1 30%;
  padding: 1em;
  border-radius: 6px;
  display: flex;
  flex-direction: column;

  & > img {
    min-width: 15em;
    aspect-ratio: 4/3;
    object-fit: cover;
    width: 100%;
    border-radius: ${(props) => props.theme.sizes.borderRadius};
  }

  & > span {
    display: block;
    margin: 1em 0 0.5em 0;
    ${DefaultFont};
    font-weight: 600;
    @media ${(props) => props.theme.media.phone} {
      font-weight: 600;
    }
  }

  & > p {
    margin: 0.5em 0 1em 0; // Adjusted margins to give it some spacing
    flex: 1; // This will make the p content take any available space, but not push AuthDiv too far
  }

  &:hover {
    background: #f6f8fd;
  }
`;

export const BlogPostDiv = styled.div`
  background-color: white;
  display: flex;
  position: relative;
  width: 100%;
  text-align: center;
  margin: 0 auto 0;
  justify-content: center;
  padding-bottom: 80px;
`;

export const PostBlogSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  max-width: ${(props) => props.theme.sizes.maxWidthMainWindow};
  color: ${(props) => props.theme.colors.text};
  padding: 1rem;
  & > div img {
    width: 100%;
    object-fit: cover;
    margin: 12px 0 0;
    justify-self: center;
  }
  & > div h4 {
    color: ${(props) => props.theme.colors.textDimmed};
    font-weight: 400;
    font-size: 16px;
    margin-top: 8px;
    margin-bottom: 0px;
    width: 100%;
    text-align: left;
  }
  & > a {
    justify-self: start;
    font-size: ${(props) => props.theme.font.sizeTitle};
    font-weight: ${(props) => props.theme.font.weightBold};
    color: ${(props) => props.theme.colors.text};
    &:hover {
      color: ${(props) => props.theme.colors.primary};
    }
  }
  & > p {
    width: 100%;
    text-align: left;
    font-size: ${(props) => props.theme.font.sizeSubTitle};
  }
`;
